import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartSimple,
  faImage,
  faList,
  faDatabase,
  faNewspaper,
  faShareNodes,
  faCog,
  faBarChart,
  faCode,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faPhp,
  faNode,
  faCss3,
  faGoogleDrive,
  faJs,
  faAws,
  faDocker,
} from "@fortawesome/free-brands-svg-icons";
import Technos from "./Technos";

export default function Competences() {
  return (
    <div className="container">
      <div className="section-title">
        <h2>Outils maîtrisés</h2>
        <h3 className="text-xl my-5">Mes outils Web favoris :</h3>
        <Technos />
        <p>
          Tous les langages de programmation et les outils que j&apos;utilise
          pour mes projets Web et bien plus encore :
        </p>
      </div>

      <div className="row skills-content md:grid md:grid-cols-2 md:gap-2 items-stretch">
        <div className="col-lg-6 fade-up">
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon icon={faJs} className="w-4 h-4 mr-2 colorblue" />{" "}
              <strong>JAVASCRIPT</strong> : React, VueJS, TypeScript
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faCss3}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>HTML / CSS</strong> : Tailwind, Bootstrap
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faPhp}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>PHP</strong> : Symfony, Wordpress, Joomla
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faNode}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Outils BackEnd</strong> : Node, Express, Thunder Client
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faDatabase}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Bases de données</strong> : MongoDB, MySQL, MariaDB,
              PostgreSQL
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faGithub}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Outils de versioning</strong> : GIT, GITHUB, GITLAB
            </span>
          </div>
        </div>

        <div className="col-lg-6 fade-up" data-aos-delay="100">
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faAws}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Cloud</strong> : AWS, Azure, Google Cloud, OVH Cloud
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faDocker}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Conteneurisation</strong> : Docker, Kubernetes
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faCog}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Automatisation</strong> : Terraform, Ansible
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faBarChart}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Monitoring</strong> : Prometheus, Grafana
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faCode}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Scripting</strong> : Bash, Python
            </span>
          </div>
        </div>
      </div>
      <div className="mt-6 row skills-content md:grid md:grid-cols-2 md:gap-2 items-stretch">
        <div className="col-lg-6 fade-up" data-aos-delay="100">
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faImage}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Graphisme</strong> : Photoshop, Figma, Canva
            </span>
          </div>
          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faShareNodes}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Communication sur les réseaux</strong> : Facebook,
              Instagram, LinkedIn
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faList}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>SPRINT / Gestion de projet</strong> : Miro, Asana
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faNewspaper}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Newsletter</strong> : Sendinblue (Brevo)
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faChartSimple}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Suivi de trafic</strong> : Google Analytics
            </span>
          </div>

          <div>
            <span className="flex items-center">
              <FontAwesomeIcon
                icon={faGoogleDrive}
                className="w-4 h-4 mr-2 colorblue"
              />{" "}
              <strong>Bureautique</strong> : Google Drive (Docs, Sheet, Slides)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
